
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import Code from 'components/Code'
import Table, { Row, Column } from 'components/Table'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h3><inlineCode parentName="h3">{`css`}</inlineCode></h3>
    <p>{`A helper function to generate CSS from a template literal with interpolations. You need to use this if you return a
template literal with functions inside an interpolation due to how tagged template literals work in JavaScript.`}</p>
    <p>{`If you're interpolating a string you do not need to use this, only if you're interpolating a function.`}</p>
    <Table head={['Arguments', 'Description']} mdxType="Table">
  <Row mdxType="Row">
    <Column mdxType="Column">
      1. <Code mdxType="Code">TaggedTemplateLiteral</Code>
    </Column>
    <Column mdxType="Column">A tagged template literal with your CSS and interpolations.</Column>
  </Row>
    </Table>
    <p>{`Returns an array of interpolations, which is a flattened data structure that you can pass as an interpolation
itself.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import styled, { css } from 'styled-components'

const complexMixin = css\`
  color: \${props => (props.whiteColor ? 'white' : 'black')};
\`

const StyledComp = styled.div\`
  /* This is an example of a nested interpolation */
  \${props => (props.complex ? complexMixin : 'color: blue;')};
\`
`}</code></pre>
    <p>{`If you leave off the css your function will be `}<inlineCode parentName="p">{`toString()`}</inlineCode>{`ed and you'll not get the results
you expected.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;